var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTicket = function SvgTicket(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.946 6.962c.68.707 1.693.857 2.514.449l.958.996a1.05 1.05 0 0 1 0 1.442L9.83 20.86a.954.954 0 0 1-1.386 0l-.958-.996a2.37 2.37 0 0 0-.432-2.615A2.15 2.15 0 0 0 4.54 16.8l-.958-.995a1.05 1.05 0 0 1 0-1.442L14.17 3.35a.954.954 0 0 1 1.387 0l.957.996a2.37 2.37 0 0 0 .432 2.615Zm-4.165 2.166.52-.542-1.04-1.083-.521.542zm2.083 1.083-.521.541-1.041-1.083.52-.541zm1.04 2.165.521-.541-1.041-1.083-.52.541z",
    clipRule: "evenodd"
  })));
};
export { SvgTicket as ReactComponent };
export default __webpack_public_path__ + "static/media/ticket.75b9a8d354557e205e4a71e2184e5041.svg";